<template>
  <div class="file-view-container">
    <img
      style="width: 50px; padding-right: 5px"
      v-if="icon"
      :src="icon"
      alt=""
    />
    <div class="tips">
      <div>{{ file.name }}</div>
      <!-- <div>{{ file.size }}B</div> -->
    </div>
    <div class="file-btn">
      <i class="el-icon-view" v-if="type != 'rar'" @click="viewFile"></i>
      <i class="el-icon-download" @click="downloadFile"></i>
      <i v-if="!disabled" class="el-icon-delete" @click="deleteFile"></i>
    </div>
    <!-- <OfficePreviewDialog
      ref="OfficePreviewDialog"
      :url="file.url"
      :type="type"
    /> -->
  </div>
</template>
<script>
// import OfficePreviewDialog from "./view/OfficePreviewDialog.vue";
import { downloadFile2 } from "../../directives/src/downloadFile";
import { excelToPdfPreview } from "@/api/academic/academicSalary";
const imgLast = ["JPG", "JPEG", "PNG", "GIF"];
const wordLast = ["DOCX", "DOC"];
const excelLast = ["XLS", "XLSX"];
const rarLast = ["RAR", "ZIP", "ARJ", "JAR"];
export default {
  name: "FileView",
  components: {},
  props: {
    file: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    file: {
      immediate: true,
      handler(newVal) {
        this.calcType(newVal.name);
      },
    },
  },
  data() {
    return {
      icon: null,
      type: "excel",
      imgIcon: require("../../../static/image/img.png"),
      wordIcon: require("../../../static/image/word.png"),
      excelIcon: require("../../../static/image/excel.png"),
      rarIcon: require("../../../static/image/rar.png"),
    };
  },
  methods: {
    calcType(name) {
      const lastString = String(name)
        .split(".")
        [String(name).split(".").length - 1].toLocaleUpperCase();
      if (imgLast.includes(lastString)) {
        this.icon = this.imgIcon;
        this.type = "img";
      }
      if (wordLast.includes(lastString)) {
        this.icon = this.wordIcon;
        this.type = "word";
      }
      if (excelLast.includes(lastString)) {
        this.icon = this.excelIcon;
        this.type = "excel";
      }
      if (rarLast.includes(lastString)) {
        this.icon = this.rarIcon;
        this.type = "rar";
      }
    },
    deleteFile() {
      this.$emit("deleteFile");
    },
    viewFile() {
      if (this.file.url.split("com")[1]) {
        excelToPdfPreview({
          excelPath: this.file.url.split("com/")[1],
        }).then((res) => {
          const blob = new Blob([res], {
            type: "application/pdf;chartset=utf-8",
          });
          const url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        });
      }
    },
    downloadFile() {
      downloadFile2(this.file.url, this.file.name);
    },
  },
};
</script>
<style scoped lang="less">
.file-view-container {
  display: flex;
  flex-flow: row;
  align-items: center;
  text-align: left;
  .file-btn {
    padding-left: 10px;
    width: 100px;
    i {
      cursor: pointer;
      padding: 0 5px;
      font-size: 18px;
    }
  }
}
.tips {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/common/fileView.vue